import { ADVANCEFEES } from '../actionTypes';

const initialState = {
  content: [],
  advanceFeesById: {},
  addedItems: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ADVANCEFEES.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case ADVANCEFEES.SUCCESS_BY_ID:
      return {
        ...state,
        advanceFeesById: action.payload,
      };
    case ADVANCEFEES.SUCCESS_ADD_ITEMS:
      return {
        ...state,
        addedItems: action.payload,
      };
    default:
      return state;
  }
};
